import React from "react"

/**
 * Bootstrap 3 form-group element. Helps make large forms clearer and easier to read,
 * but not necessary.
 *
 * @param {object} props - The properties passed to the component.
 * @param {React.ReactNode} props.children - The children of the component, typically a label and input.
 * @param {string} [props.className="form-group"] - Override the class name for the div.
 * @returns {React.ReactNode} - A div like: \<div class="form-group">{children}\</div>
 */
export function FormGroup({
  children,
  className = "form-group",
}: {
  children: React.ReactNode
  className?: string
}): React.ReactNode {
  return <div className={className}>{children}</div>
}

export function HR({
  marginTop = "5px",
  marginBottom = "10px",
}: {
  marginTop?: string
  marginBottom?: string
}) {
  return  (
    <div className="col-sm-12">
      <hr style={{ margin: `${marginTop} 0 ${marginBottom} 0` }} />
    </div>
  )
}
